var map = {
	"./ans.webp": 5575,
	"./bankist.webp": 7055,
	"./forkify.webp": 8868,
	"./giard.webp": 2200,
	"./goatweb.webp": 363,
	"./mapty.webp": 4600,
	"./natours.webp": 5546,
	"./nexter.webp": 8615,
	"./omnifood.webp": 5159,
	"./simon.webp": 4432,
	"./tindog.webp": 5505,
	"./trillo.webp": 898,
	"./vat.webp": 764,
	"./zst.webp": 5848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;